<template>
    <div class="bg-white relative flex items-center justify-center rounded-2xl p-2 px-6 overflow-scroll" style="width: 70vw; height: 60vh">
        <div @click="closeModal" class="text-customGray absolute top-5 right-5 text-sm cursor-pointer w-full flex justify-end z-20 mb-3">
          <XIcon class="w-5 h-5"/>
        </div>
        <div class="w-full flex flex-col md:flex-row -mt-10 p-2">
          <div class="w-full md:w-2/3">
            <img id="image" class="max-h-96" :src="imgSrc"/>
          </div>
          <div class="w-full md:w-1/3 flex items-center pl-0 md:pl-4">
            <div class="w-full p-0 md:p-4">
              <div class="w-full mt-5 md:mt-0">
                <h1 class="text-xl md:text-3xl text-80 font-medium">Select aspect ratio</h1>
              </div>
              <div class="w-full my-5 md:my-10">
                <div class="form-check">
                  <input class="form-check-input appearance-none rounded-full h-4 w-4 border text-aquamarine border-gray-300 bg-gray-400 checked:bg-aquamarine checked:border-gray-300 focus:bg-aquamarine focus:border-gray-300 focus:outline-none mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="radio" name="aspect_ratio" checked @click="onAspectRatioChange(1)">
                  <label class="form-check-label inline-block text-gray-800">
                    1:1
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input appearance-none rounded-full h-4 w-4 border text-aquamarine border-gray-300 bg-gray-400 checked:bg-aquamarine checked:border-gray-300 focus:outline-none mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="radio" name="aspect_ratio" @click="onAspectRatioChange(1.91/1)">
                  <label class="form-check-label inline-block text-gray-800">
                    1.91:1
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input appearance-none rounded-full h-4 w-4 border text-aquamarine border-gray-300 bg-gray-400 checked:bg-aquamarine checked:border-gray-300 focus:outline-none mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="radio" name="aspect_ratio" @click="onAspectRatioChange(4/5)">
                  <label class="form-check-label inline-block text-gray-800">
                    4:5
                  </label>
                </div>
              </div>
              <button class="w-full h-10 text-white font-medium rounded-md bg-aquamarine hover:bg-aquamarineFire cursor-pointer" @click="onCropImage">Crop</button>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import Cropper from "cropperjs";
import 'cropperjs/dist/cropper.css';

import XIcon from "@/components/svg/XIcon";

export default {
  name: "ImageCropperModal",

  components: {
    XIcon
  },

  props: {
    imgSrc: { required: true, type: String },
  },

  data: () => ({
    cropper: null
  }),

  mounted() {
    if (this.imgSrc !== '') {
        const image = document.getElementById("image");
        this.cropper = new Cropper(image, {
            viewMode: 1,
            aspectRatio: 1
        });
    }
  },

  methods: {
    close: function() {
      return modalController.dismiss();
    },

    onCropImage: function() {
        let image = this.cropper.getCroppedCanvas().toDataURL();
        this.$emit('crop', image);
        this.closeModal();
    },

    closeModal() {
        this.cropper.destroy();
        this.$emit('closeModal');
    },

    onAspectRatioChange(aspectRatio){
      this.cropper.destroy();
      
      const image = document.getElementById("image");
      setTimeout(() => {
        this.cropper = new Cropper(image, {
            viewMode: 1,
            aspectRatio: aspectRatio
        });
      }, 100);
    }
  },
};
</script>

<style lang="scss" scoped>
input[type="radio"]:focus {
  outline: max(2px, 0.15em) solid currentColor;
  outline-offset: max(2px, 0.15em);
}
input[type='radio']:checked {
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='#5bd9a4' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e");
}
</style>